import React from 'react';
import { Link } from 'gatsby';
import { Image } from '../common';

interface ArticleProps {
  post: any;
}

export default function Article({ post }: ArticleProps) {
  const { slug } = post.fields;
  const { title, published, keywords, authors, image } = post.frontmatter;
  return (
    <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
      {/* lg:h-48 md:h-36 w-full object-cover object-center */}
      <Image className="aspect-w-16 aspect-h-9" filename={image} alt="blog" />
      <div className="p-6">
        <h3 className="tracking-widest text-xs title-font font-medium text-gray-400 mb-1 h-8 overflow-hidden">
          {keywords.join(', ') || 'Caso Radiográfico'}
        </h3>
        <h2 className="title-font text-lg font-medium text-gray-900 my-2">
          {title?.replace('\\n', '')}
        </h2>
        <p className="tracking-widest text-xs title-font font-medium text-gray-400 mb-2 overflow-hidden">
          {published}
        </p>
        <p className="leading-relaxed mb-3">
          {authors.map((author) => author.name).join(', ')}
        </p>
        <div className="flex items-center flex-wrap ">
          <Link
            to={`/reporte-imagenologico${slug}`}
            className="text-blue-500 inline-flex items-center md:mb-2 lg:mb-0"
          >
            Ver Caso
            <svg
              className="w-4 h-4 ml-2"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14" />
              <path d="M12 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
}
